export default "__VITE_ASSET__fCccrifn__"